import $ from 'jquery';

class MetaBox {

    constructor() {
        this.params = wc_stripe_order_metabox_params;
        this.initialize();
    }

    initialize() {
        $(document.body)
            .on('click', '.do-stripe-transaction-view', this.renderChargeView.bind(this))
            .on('click', '.do-api-capture', this.doApiCapture.bind(this))
            .on('click', '.do-api-cancel', this.doApiCancel.bind(this))
            .on('click', '.wc-stripe-pay-order', this.openPayOrderModal.bind(this))
            .on('change', '#customer_user', this.fetchPaymentMethods.bind(this))
            .on('order-totals-recalculate-success', this.clearTransactionData.bind(this))
            .on('keyup', '[name="capture_amount"]', this.validateCaptureAmount.bind(this))
            .on('items_saved', this.clearTransactionData.bind(this));
    }

    clearTransactionData() {
        $('.do-stripe-transaction-view').data('charge', null);
    }

    validateCaptureAmount(e) {
        const value = parseFloat($(e.currentTarget).val());
        if (!Number.isNaN(value)) {
            const data = $('.do-stripe-transaction-view').data('charge');
            if (data && value < parseFloat(data.order_total)) {
                if (typeof woocommerce_admin !== 'undefined') {
                    woocommerce_admin.capture_notice = this.params.messages.capture_amount;
                    $(document.body).triggerHandler('wc_add_error_tip', [$(e.currentTarget), 'capture_notice']);
                }
            } else {
                $(document.body).triggerHandler('wc_remove_error_tip', [$(e.currentTarget), 'capture_notice']);
            }
        }
    }

    renderChargeView(e) {
        e.preventDefault();
        const $icon = $(e.currentTarget);
        if (!$icon.data('charge')) {
            $icon.addClass('disabled');
            $.ajax({
                method: 'GET',
                dataType: 'json',
                url: this.params.routes.charge_view,
                data: {
                    order_id: $icon.data('order'),
                    _wpnonce: this.params._wpnonce
                }
            }).done((response) => {
                if (!response.code) {
                    $icon.data('charge', response.data).removeClass('disabled');
                    $icon.WCBackboneModal({
                        template: 'wc-stripe-view-transaction',
                        variable: response.data
                    });
                } else {
                    window.alert(response.message);
                }
            }).fail((jqXHR, textStatus, errorThrown) => {
                $icon.removeClass('disabled');
                window.alert(errorThrown);
            });
        } else {
            $icon.WCBackboneModal({
                template: 'wc-stripe-view-transaction',
                variable: $icon.data('charge')
            });
        }
    }

    doApiCapture(e) {
        e.preventDefault();
        const $modal = $('.wc-transaction-data');
        this.block($modal);
        $.ajax({
            method: 'POST',
            dataType: 'json',
            url: this.params.routes.capture,
            data: {
                _wpnonce: this.params._wpnonce,
                order_id: woocommerce_admin_meta_boxes.post_id,
                amount: $('[name="capture_amount"]').val()
            }
        }).done((response) => {
            if (!response.code) {
                window.location.reload();
            } else {
                this.unblock($modal);
                window.alert(response.message);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.unblock($modal);
            window.alert(errorThrown);
        });
    }

    doApiCancel(e) {
        e.preventDefault();
        const $modal = $('.wc-transaction-data');
        this.block($modal);
        $.ajax({
            method: 'POST',
            dataType: 'json',
            url: this.params.routes.void,
            data: {
                _wpnonce: this.params._wpnonce,
                order_id: woocommerce_admin_meta_boxes.post_id
            }
        }).done((response) => {
            if (!response.code) {
                window.location.reload();
            } else {
                this.unblock($modal);
                window.alert(response.message);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.unblock($modal);
            window.alert(errorThrown);
        });
    }

    openPayOrderModal(e) {
        e.preventDefault();
        $(e.target).WCStripePayOrderBackboneModal({
            template: 'wc-stripe-modal-pay-order',
            params: {
                customer_id: $('#customer_user').val(),
                payment_methods: wc_stripe_order_metabox_params.payment_methods,
                order_id: $('#post_ID').val()
            }
        });
    }

    fetchPaymentMethods() {
        wc_stripe_order_metabox_params.payment_methods = [];
        const customer_id = $('#customer_user').val();
        if (customer_id) {
            $.ajax({
                method: 'GET',
                dataType: 'json',
                url: this.params.routes.payment_methods,
                data: {
                    _wpnonce: this.params._wpnonce,
                    customer_id
                }
            }).done((response) => {
                wc_stripe_order_metabox_params.payment_methods = response.payment_methods;
            });
        }
    }

    block($el) {
        $el.block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });
    }

    unblock($el) {
        $el.unblock();
    }
}

$(() => {
    if (typeof wc_stripe_order_metabox_params !== 'undefined') {
        new MetaBox();
    }
});
